// Generated types for ComponentMatchTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityMatchTaskReadAPI, EntityMatchTaskWriteAPI } from './entitymatchtask';
import { EntityMatchTaskReadAPISchemaObject, EntityMatchTaskWriteAPISchemaObject } from './entitymatchtask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ComponentMatchTaskReadAPI extends EntityMatchTaskReadAPI {
}

export interface ComponentMatchTaskWriteAPI extends EntityMatchTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ComponentMatchTaskReadAPISchema: z.ZodType<ComponentMatchTaskReadAPI> = EntityMatchTaskReadAPISchemaObject.extend({}).passthrough();

export const ComponentMatchTaskWriteAPISchema: z.ZodType<ComponentMatchTaskWriteAPI> = EntityMatchTaskWriteAPISchemaObject.extend({}).passthrough();
